module.exports = __webpack_public_path__ + "img/pei5.349ccfc6.jpg";